require("./saved-items.scss");

(function ($, savedItemsData) {
    const apiUrl = savedItemsData.apiUrl;
    const get = (url) => fetch(url,
        {
            method: "GET",
            credentials: "same-origin",
            headers: { 'Content-Type': "application/json" }
        });

    const post = (url, data) => fetch(url,
        {
            method: "POST",
            credentials: "same-origin",
            headers: { 'Content-Type': "application/json" },
            body: data ? JSON.stringify(data) : ""
        });

    const del = (url) => fetch(url,
        {
            method: "DELETE",
            credentials: "same-origin",
            headers: { 'Content-Type': "application/json" }
        });

    const loadStatus = () => {

        const expClassName = '';
        if (window.optimizelyUtil) {
            var experiment = window.optimizelyUtil.getVariation('save-item-icon-test');

            if (experiment === 'B') {
                expClassName = 'save-item-b';
            }
        }

        let ids = $(".save-item[data-item-id]").map((i, elm) => {
            if (expClassName) {
                $(elm).addClass(expClassName);
            }
            return $(elm).data("itemId");
        });

        ids = $.makeArray(ids).join(",");

        if (ids.length > 0) {
            const url = `${apiUrl}?ids=${ids}&random=${new Date().getTime()}`;
            get(url)
                .then(x => {
                    x.json().then(y => {
                        y.filter(e => e.saved).forEach((el) => {
                            var elm = $(`.save-item[data-item-id=${el.id}]`);
                            elm.addClass("saved").attr("data-webm-clickValue", "unsave-item");
                        });
                    });
                });
        }
    };

    const loadComponents = () => {
        $("#save_item_buttons").children().each(function () {
            const elm = $(this);
            $(elm.data("target")).append(elm);
        });
    };

    $(() => {
        loadComponents();
        loadStatus();

        $(".save-item-actions a").click(function () {
            window.location.href = `${$(this).data("href")}?${$(this).data("returnUrlKey")}=${window.location.href}`;
        });

        $("body").on("click", ".save-item[data-item-id]", function (e) {
            e.preventDefault();

            if (!savedItemsData.isAuthenticated) {
                $.colorbox({ inline: true, href: "#saved_items_requires_authentication_dialog", transition: "none" });
            } else {
                const elm = $(this);
                const itemId = elm.data("itemId");
                const url = `${apiUrl}${itemId}`;

                if (elm.hasClass("saved")) {
                    elm.removeClass("saved");
                    del(url)
                        .then(x => {
                            if (x.ok) {
                                elm.attr("data-webm-Clickvalue", "save-item");
                            } else {
                                elm.addClass("saved");
                            }
                        });
                } else {
                    elm.addClass("saved");
                    post(url)
                        .then(x => {
                            if (x.ok) {
                                elm.attr("data-webm-Clickvalue", "unsave-item");
                            } else {
                                elm.removeClass("saved");
                            }
                        });
                }
            }
        });
    });

})(jQuery, window.saved_items_data);